export default function TrustSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-[60%]">
            <p className="text-xs font-semibold text-foreground-500 uppercase tracking-widest mb-4">
              &bull; Verified Reviews
            </p>
            <blockquote className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-[1.35] italic max-w-lg">
              &ldquo;The Hipobuy spreadsheet completely changed how I shop. I used to spend hours scrolling through products, now I find exactly what I want in minutes. The QC photos alone have saved me from so many bad purchases.&rdquo;
            </blockquote>
            <div className="mt-6 flex items-center gap-3">
              <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20stylish%20modern%20man%20with%20clean%20look%20against%20warm%20neutral%20studio%20background%2C%20soft%20flattering%20lighting%2C%20editorial%20quality%2C%20genuine%20expression&width=120&height=120&seq=review-avatar-v2&orientation=squarish"
                  alt="Marcus"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950">Marcus T.</p>
                <div className="flex items-center gap-1">
                  <div className="w-4 h-4 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-sm"></i>
                  </div>
                  <span className="text-xs text-foreground-500">Verified Buyer &bull; Los Angeles</span>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[40%]">
            <div className="relative rounded-3xl overflow-hidden bg-background-100 aspect-[3/4]">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20fashion%20portrait%20of%20a%20stylish%20person%20looking%20confidently%20ahead%20with%20warm%20natural%20lighting%20on%20a%20soft%20cream%20background%2C%20artistic%20photography%2C%20gentle%20contrast%2C%20minimal%20composition%2C%20professional%20quality%2C%20elegant%20mood&width=700&height=933&seq=trust-portrait-v2&orientation=portrait"
                alt="Review"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}